
import { defineComponent, onMounted, ref } from 'vue'
import wxButton from '@/components/wxButton'
import request from '@/utils/request'
import { Sticky } from 'vant'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const wx = require('weixin-js-sdk')
export default defineComponent({
  name: 'bindSuccess',
  components: {
    wxButton,
    Sticky
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const successImgUrl = require('@/assets/sucess/success.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const iconUrl = require('@/assets/sucess/icon.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const intellegentUrl = require('@/assets/sucess/intelligent.png')
    const baseUrl = window.location.href.split('#')[0]
    const isApp = ref(false)
    const path = ref('pages/start/start')
    const LoginUser = () => {
      request({
        url: `/wxapp/getWxConfig`,
        data: { url: baseUrl },
        params: null,
        method: 'post'
      }).then((configRes: any) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configRes.appId,
          timestamp: configRes.timestamp, // 必填，生成签名的时间戳
          nonceStr: configRes.nonceStr, // 必填，生成签名的随机串
          signature: configRes.signature, // 必填，签名
          jsApiList: ['onMenuShareAppMessage', 'addEventListener'],
          openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        wx.ready(function () {
          console.log('ready')
          // window.open('https://'+host+'/h5/#/pages/message/index/index')
        })
        wx.error((res: any) => {
          console.log('wx.error', res)
        })
      })
    }

    onMounted(() => {
      const ua: any = navigator.userAgent.toLowerCase()
      if (ua && ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv((res: any) => {
          if (res.miniprogram) {
            console.log('在小程序里')
            // wx.miniProgram.redirectTo({
            //   url: '/pages/login/login'
            // })
            isApp.value = true
          } else {
            console.log('在公众号里')
            request({
              url: `/getUserInfo`,
              params: null,
              method: 'get'
            }).then((res1: any) => {
              const sn = res1.data.sn
              path.value = `${path.value}?sn=${sn}`
            })
          }
        })
      } else {
        console.log('不在微信里')
      }
      LoginUser()
    })
    const redirectToWechat = () => {
      wx.miniProgram.redirectTo({
        url: '/pages/login/login'
      })
    }

    const onHandleCancal = () => {
      console.log('1111')
      request({
        url: '/wxapp/xd/user/cancelBind',
        method: 'POST'
      }).then(res => {
        if (res.status) {
          window.location.href = res.data as string
        }
      })
    }
    return {
      successImgUrl,
      iconUrl,
      intellegentUrl,
      isApp,
      redirectToWechat,
      onHandleCancal,
      path
    }
  }
})
